import api from "./apiService";

// fetch all the referrers in the system
export function getReferrers() {
  return api
    .get(
      `/admin/referrals/referrers`
    )
    .then(data => {
      return data.data;
    })
    .catch(error => {
      return error.response;
    });
}

// fetch the withdrawal requests of referrers
export function getWithdrawalRequests(page, limit, status) {
  return api
    .get(`/admin/referrals/withdrawal-requests?page=${page}&limit=${limit}&status=${status}`)
    .then(data => {
      return data.data;
    })
    .catch(error => {
      return error.response;
    });
}

// fetch a referrer's details from the system
export function getReferrerDetails(id, page, limit, status) {
  return api
    .get(`/admin/referrals/referrer/earning/${id}?page=${page}&limit=${limit}&status=${status}`)
    .then(data => {
      return data.data;
    })
    .catch(error => {
      return error.response;
    });
}

// mark a withdrawal request as paid
export function markWithdrawalRequestAsPaid(id) {
  return api
    .patch(`/admin/referrals/withdrawal-requests/mark-as-paid/${id}`, {"status": "paid"})
    .then(data => {
      return data.data;
    })
    .catch(error => {
      return error.response;
    });
}

// approve a withdrawal request
export function updateWithdrawalRequest(id, status) {
  return api
    .patch(`/admin/referrals/withdrawal-requests/${id}`, {"status": status})
    .then(data => {
      return data.data;
    })
    .catch(error => {
      return error.response;
    });
}


//////////////////
// WEBPACK FOOTER
// ./services/referral.js
// module id = null
// module chunks = 